<!--
 * @Date: 2023-07-27 17:05:53
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @LastEditTime: 2024-02-06 15:34:20
 * @Description: echarts基类
-->
<template>
  <div ref="chart" v-displayed="handleDisplayed" :class="['lc-chart', ...this.chartClass]">
    <ZoomupChart ref="zoomup" @displayed="zoomupDisplayed" />
  </div>
</template>

<script>
import ZoomupChart from './showChart.vue';

export default {
  name: 'ChartBase',
  components: {
    ZoomupChart
  },
  props: {
    data: {
      type: [Array, Object],
      default: () => []
    },
    options: {
      type: Object,
      default: () => {}
    },
    mapOptions: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        this.preRenderChart();
      }
    }
  },
  data() {
    return {
      // 可以使用dataset白名单
      datasetWhiteList: ['LcChartHistogram', 'LcChartBrokenLine', 'LcChartPie', 'LcChartFunnel'],
      myChart: null,
      myZoomupChart: null,
      chartClass: [],
      chartOptions: null,
      chartData: [],
      // 工具
      feature: {
        myZoomup: {
          show: true,
          title: '查看',
          onclick: this.showZoomup,
          icon: 'path://M904.358621 343.844186l-71.980381-71.980381-184.411033 184.440709-80.244602-80.274278L752.133637 191.619202l-71.980381-71.980381c0-30.953989 25.069979-56.051597 56.050574-56.051597l168.153768 0c30.983665 0 56.053644 25.097608 56.053644 56.051597l0 168.153768C960.412264 318.746578 935.342286 343.844186 904.358621 343.844186zM343.844697 904.360156c0 30.953989-25.125237 56.050574-56.051597 56.050574L119.639333 960.41073c-30.982642 0-56.05262-25.096585-56.05262-56.050574L63.586712 736.206388c0-30.953989 25.069979-56.050574 56.05262-56.050574l71.979358 71.980381 184.412057-184.440709 80.245625 80.274278L271.863293 832.40638 343.844697 904.360156z'
        }
      }
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    this.myChart && this.myChart.dispose();
    this.myChart = null;
  },
  methods: {
    preRenderChart() {
      if (Object.keys(this.options).length && this.data.length && !this.chartOptions) {
        // 处理数据
        if (typeof this.processChartData == 'function') {
          this.processChartData(this.data);
        } else {
          this.chartData = data;
        }
        // 处理options
        if (typeof this.processOptions == 'function') {
          this.processOptions(this.options);
        } else if (this.datasetWhiteList.includes(this.$options.name)) {
          // 没有配置映射关系且是可以使用dataset的图表
          this.chartOptions = Object.assign({}, this.options, {
            dataset: {
              source: this.chartData
            }
          });
        } else {
          this.chartOptions = this.options;
        }
        this.addToolbox();
      }
      this.renderChart();
    },
    showZoomup() {
      this.$refs.zoomup.showChart(this.chartOptions.title?.text || '');
    },
    zoomupDisplayed(el) {
      if (!this.myZoomupChart) {
        this.myZoomupChart = this.getCurrentEcharts().init(el);
      }
      this.myZoomupChart.setOption(
        Object.fromEntries(Object.entries(this.chartOptions).filter(([key, value]) => key !== 'toolbox')),
        true
      );
    },
    // 添加工具配置项
    addToolbox() {
      if (this.chartOptions.toolbox) {
        Object.keys(this.chartOptions.toolbox.feature).forEach(tool => {
          this.chartOptions.toolbox.feature[tool] = {
            ...this.feature[tool],
            ...this.chartOptions.toolbox.feature[tool]
          };
        });
      }
    },
    handleDisplayed() {
      if (!this.myChart) {
        this.myChart = this.getCurrentEcharts().init(this.$refs.chart);
        this.preRenderChart();
      }
    },
    handleWindowResize() {
      this.myChart && this.myChart.resize();
    },
    renderChart() {
      this.myChart && this.chartOptions && this.myChart.setOption(this.chartOptions, true);
    }
  }
};
</script>
<style lang="scss">
@import '@/styles/mixin.scss';
.lc-chart {
  @include createCssFromWidthHeightStyle('&');
  @include createCssByAttributesGroup('&', aspect-ratio);
  @include createCssByAttributesGroup('&', max-width);
}
</style>
